<app-carousel>

  <ng-template carouselItem="1">
    <ng-container *ngTemplateOutlet="matDescriptionContent"></ng-container>
  </ng-template>

  @if (inventoryModule && resources.length > 0) {
    <ng-template carouselItem="2">
      <mat-card appearance="outlined" class="mat-card-c">
        <mat-card-content class="mat-body-1">
          <h2 style="display: flex; justify-content: center;"><strong>Recursos</strong></h2>
          <app-button-label [labelsEdit]="labels"></app-button-label>
          <data-table
            [title]="''"
            [columns]="columnsResouces"
            [configuration]="configurationResouces"
            [url]="urlGetTablaResourcesAuthorization"
            [params]="paramsResourcesAuthorization"
            (internalData)="dataResources($event)">
          </data-table>
        </mat-card-content>
      </mat-card>
    </ng-template>
  }

  <ng-template carouselItem="3" >
    <mat-card #commentsSection appearance="outlined" class="mat-card-c">
      <mat-card-content class="mat-body-1">
        <data-table
          [title]="titleC"
          [columns]="columnsComments"
          [configuration]="configurationComments"
          [reloadTable]="reloadComments"
          [url]='EndpointDictionary.WorkOrder.COMMENTS.TABLE'
          [params]="paramsComments"
          (delete)="deleteComments($event)"
          (add)="addComments($event)"
          (edit)="editComments($event)"
          (fileIconClick)="onFileIconClick($event)"
          >
        </data-table>
      </mat-card-content>
    </mat-card>
  </ng-template>
</app-carousel>

<ng-container  *ngTemplateOutlet="buttons"></ng-container>

<ng-template #matDescriptionContent>

  <mat-card appearance="outlined" class="mat-card-c" [style]="viewCarousel ? 'height: 70vh' : ''">
    <mat-card-content class="mat-body-1">
      @if (commentButton) {
        <div class="comment-btn-top-right">
          <button color="primary" mat-icon-button
            (click)="onAddCommentClick()"
            matTooltip="Agregar comentario">
            <i class="fa fa-comments"></i>
          </button>
        </div>
      }

      <h2 [style]="commentButton ? 'width: 90%' : ''"><strong>{{titleNotification}}: {{bodyOrder.code}}</strong></h2>
      <h3>Número de orden: {{bodyOrder.consecutive}}</h3>
      @if (showMantenanceType) {
        <h3>Tipo de Mantenimiento: {{bodyOrder.maintenanceType}}</h3>
      }
      <h3>Descripción: {{bodyOrder.description}}</h3>
      <h3>Responsable: {{bodyOrder.responsible}}</h3>
      <h3>Fecha ejecución: {{bodyOrder.executionDate}}</h3>
      @if (!inventoryModule) {
        <h3>Recursos: {{bodyOrder.resources}}</h3>
      }
      @if (showCost) {
        <h3>Costo Mantenimiento: {{bodyOrder.cost | thousandSeparator}}</h3>
      }
      @if (inventoryModule) {
        <h3>Costo Recursos: {{totalCostItems | thousandSeparator}}</h3>
      }
      @if (bodyOrder.odometer) {
        <h3>Medidor (horas/km/ciclos): {{bodyOrder.odometer | thousandSeparator}}</h3>
      }
      <hr>
        @if (showResponsibles) {
          <div>
            <h3><strong>Quién realiza el mantenimiento</strong></h3>
            @for (item of bodyUser; track item) {
              <div>
                <h3>Encargado: {{item.name}}</h3>
              </div>
            }
          </div>
        }
        <h5>{{note}}</h5>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #buttons>
    <div  class="button" style="justify-content: center;">
      @if (closeButton) {
        <button color="warn" class="button-save mat-elevation-z5" style="width: 70%" mat-raised-button
        (click)="closeOrder.emit()">Cerrar Orden de trabajo</button>
      }

      @if (packOffButton) {
        <button style="width: 65%;" color="primary" class="button-save mat-elevation-z5" mat-raised-button
        (click)="dispatchResources()">Despachar Recursos</button>
      }
    </div>

    @if (declineButton) {
      <div class="button" style="justify-content: space-between;">
        <button style="width: 45%;" color="warn" class="button-save mat-elevation-z5" mat-raised-button
        (click)="responseAutorization.emit([false, bodyOrder, bodyUser, resources, inventoryModule])">Rechazar</button>
        @if (acceptButton) {
          <button style="width: 45%;" color="primary" class="button-save mat-elevation-z5"
          mat-raised-button (click)="responseAutorization.emit([true, bodyOrder, bodyUser, resources, inventoryModule])">Autorizar</button>
        }
      </div>
    }
  </ng-template>